import React, { useState, useEffect } from 'react';
import BuildingForm from './BuildingForm';
import SearchableSelect from './SearchableSelect';
import countiesData from '../data/counties.json';

const LocationForm = ({ location, onChange, onRemove, index, selectedState }) => {
  const [availableCounties, setAvailableCounties] = useState([]);

  useEffect(() => {
    if (selectedState) {
      const stateData = countiesData.find(state => state.state === selectedState);
      if (stateData) {
        setAvailableCounties(stateData.counties);
      } else {
        setAvailableCounties([]);
      }
    } else {
      setAvailableCounties([]);
    }
  }, [selectedState]);

  const handleChange = (field, value) => {
    onChange(index, { ...location, [field]: value });
  };

  const handleBuildingChange = (buildingIndex, updatedBuilding) => {
    const buildings = [...(location.buildings || [])];
    buildings[buildingIndex] = updatedBuilding;
    onChange(index, { ...location, buildings });
  };

  const handleAddBuilding = () => {
    const buildings = [...(location.buildings || []), { id: Date.now().toString() }];
    onChange(index, { ...location, buildings });
  };

  const handleRemoveBuilding = (buildingIndex) => {
    const buildings = location.buildings.filter((_, i) => i !== buildingIndex);
    onChange(index, { ...location, buildings });
  };

  return (
    <div className="card mb-3">
      <div className="flex-between mb-3">
        <h3>Location {index + 1}</h3>
        <button 
          type="button" 
          className="btn btn-danger" 
          onClick={() => onRemove(index)}
        >
          Remove Location
        </button>
      </div>

      <div className="grid mb-3">
        <div className="form-group">
          <label>County</label>
          {selectedState ? (
            <SearchableSelect
              options={availableCounties}
              value={location.county || ''}
              onChange={(value) => handleChange('county', value)}
              placeholder="Select county..."
            />
          ) : (
            <input
              type="text"
              className="form-control"
              value=""
              placeholder="Please select a state first"
              disabled
            />
          )}
          {selectedState && availableCounties.length === 0 && (
            <small className="text-muted">No counties available for selected state</small>
          )}
        </div>

        <div className="form-group">
          <label>Distance to Coast (miles)</label>
          <input
            type="number"
            className="form-control"
            value={location.distanceToCoast || ''}
            onChange={(e) => handleChange('distanceToCoast', e.target.value)}
            placeholder="Enter distance"
            min="0"
            step="0.01"
          />
          <small className="text-muted">Enter 0 for barrier island</small>
        </div>
      </div>

      <div>
        <div className="flex-between mb-3">
          <h4>Buildings</h4>
          <button 
            type="button" 
            className="btn btn-primary" 
            onClick={handleAddBuilding}
          >
            Add Building
          </button>
        </div>

        {location.buildings && location.buildings.map((building, buildingIndex) => (
          <BuildingForm
            key={buildingIndex}
            building={building}
            onChange={handleBuildingChange}
            onRemove={handleRemoveBuilding}
            index={buildingIndex}
          />
        ))}

        {(!location.buildings || location.buildings.length === 0) && (
          <p className="text-muted">No buildings added. Click "Add Building" to start.</p>
        )}
      </div>
    </div>
  );
};

export default LocationForm;